import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {userLogout} from "../services/authenticationService.ts";
import {authenticationAtom} from "../store/authenticationStore.ts";
import {useSetAtom} from "jotai";
import {swallowException} from "../utils/appUtils.ts";
import {isLoggingOutAtom} from "../store/authenticationStore.ts";

export function useLogout() {
    //We need this for soft logout, otherwise there flickering because of the router
    const setIsLoggingOut = useSetAtom(isLoggingOutAtom);
    const navigate = useNavigate();
    const refreshAuth = useSetAtom(authenticationAtom);

    const logout = useCallback(async () => {
        setIsLoggingOut(true);
        navigate("/login");
        try {
            await userLogout();
            refreshAuth();
        } catch {
            swallowException();
        } finally {
            setIsLoggingOut(false);
        }
    }, [navigate, setIsLoggingOut, refreshAuth]);

    return {logout};
}
